import { Controller } from "@hotwired/stimulus"

// Manages the agent builder form interactions.
// Auto-generates a slug from the agent name if slug is empty.
export default class extends Controller {
  static targets = ["name", "slug"]

  connect() {
    // Auto-slug on name input if slug is blank
    const nameInput = this.element.querySelector('[name="ai_agent[name]"]')
    const slugInput = this.element.querySelector('[name="ai_agent[slug]"]')

    if (nameInput && slugInput) {
      nameInput.addEventListener("input", () => {
        if (!slugInput.value) {
          slugInput.value = nameInput.value
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, "-")
            .replace(/^-+|-+$/g, "")
        }
      })
    }
  }
}
